// import pimg1 from '../images/project/1.jpg'
// import pimg2 from '../images/project/2.jpg'
// import pimg3 from '../images/project/3.jpg'
// import pimg4 from '../images/project/4.jpg'
// import pimg5 from '../images/project/2.jpg'

import pimg1 from '../images/faxian-it-images/clients/client-1.png'
import pimg2 from '../images/faxian-it-images/clients/client-2.png'
import pimg3 from '../images/faxian-it-images/clients/client-3.png'
import pimg4 from '../images/faxian-it-images/clients/client-4.png'
import pimg5 from '../images/faxian-it-images/clients/client-5.png'
import pimg6 from '../images/faxian-it-images/clients/client-6.png'
import pimg7 from '../images/faxian-it-images/clients/client-7.png'
import pimg8 from '../images/faxian-it-images/clients/client-8.png'
import pimg9 from '../images/faxian-it-images/clients/client-9.png'
import pimg10 from '../images/faxian-it-images/clients/client-10.png'
import pimg11 from '../images/faxian-it-images/clients/client-11.png'
import pimg12 from '../images/faxian-it-images/clients/client-12.png'




const Projects = [
    {
        id: '1',
        title: 'Consulting Project',
        subtitle: 'Development / Idea',
        slug: '1',
        pimg1: pimg1,
        // date: 'Feb 2024',
        // location: 'Austria',
        // type: 'Investment planning',
        // service: 'It, Company',
        // duration: '12 Years',
        // add: 'Millington, Ave, TN 38053',
        // architect: 'Don Johnson',
        // share: 'It, Company',
        // fax: ' 568 746 987'
    },
    {
        id: '2',
        title: 'Product Design',
        subtitle: 'Product / Idea',
        slug: '2',
        pimg1: pimg2,
      
    },
    {
        id: '3',
        title: 'Web Development',
        subtitle: 'Web / Design',
        slug: '3',
        pimg1: pimg3,
    
    },
    {
        id: '4',
        title: 'eCommerce Project',
        subtitle: 'Design / Idea',
        slug: '4',
        pimg1: pimg4,
      
    },
    {
        id: '5',
        title: 'Consulting Project',
        subtitle: 'Development / Idea',
        slug: '5',
        pimg1: pimg5,
    },
    {
        id: '6',
        title: 'Consulting Project',
        subtitle: 'Development / Idea',
        slug: '6',
        pimg1: pimg6,
    },
    {
        id: '7',
        title: 'Consulting Project',
        subtitle: 'Development / Idea',
        slug: '7',
        pimg1: pimg7,
    },
    {
        id: '8',
        title: 'Consulting Project',
        subtitle: 'Development / Idea',
        slug: '8',
        pimg1: pimg8,
    },
    {
        id: '9',
        title: 'Consulting Project',
        subtitle: 'Development / Idea',
        slug: '9',
        pimg1: pimg9,
    },
    {
        id: '10',
        title: 'Consulting Project',
        subtitle: 'Development / Idea',
        slug: '10',
        pimg1: pimg10,
    },
    {
        id: '11',
        title: 'Consulting Project',
        subtitle: 'Development / Idea',
        slug: '11',
        pimg1: pimg11,
    },
    {
        id: '12',
        title: 'Consulting Project',
        subtitle: 'Development / Idea',
        slug: '12',
        pimg1: pimg12,
    },



]
export default Projects;